import React from 'react'

import { 
    MenuItem,
    TextField,
} from '@material-ui/core'

import MESSAGE from '../../business-const/Message/Message'

import {
    COLOR
} from '../../business-const/Color/Color'

import {
    FONTSIZE,
    FONTWEIGHT,
} from '../../business-const/Style/Style'

import { 
    TextFieldText,
    TextFieldNumber,
} from './TextField'

import {
    CampoDisabled,
} from '../TextFieldValidator/TextFieldValidator'

import {
    sortAsc
} from '../Sort/Sort'

import {
    pesquisaList,
    pesquisaDescricaoList,
} from '../../business-rules/List/ListService'



// RenderValue
// -----------

const TextFieldRenderValue = props => {
    return (
        <TextField
            className="w-full"
            variant="standard" 
            size="medium" 
            value={props.listExibirCodigo ? props.option : pesquisaList(props.list, props.option).descricao}
            multiline={true}
            InputProps={{
                style: {
                    padding: 0,
                    fontSize:
                        props.destaque === 'sim'
                            ?
                                FONTSIZE().TextFieldSelectRenderValueDestaque
                            :
                                props.corDestaque
                                    ?
                                        FONTSIZE().TextFieldSelectRenderValueCorDestaque
                                    :
                                        FONTSIZE().TextFieldSelectRenderValue,
                    fontWeight:
                        props.destaque === 'sim'
                            ?
                                FONTWEIGHT().TextFieldSelectRenderValueDestaque
                            :
                                props.corDestaque
                                    ?
                                        FONTWEIGHT().TextFieldSelectRenderValueCorDestaque
                                    :
                                        FONTWEIGHT().TextFieldSelectRenderValue,
                    color: props.corDestaque ? props.corDestaque : props.report ? COLOR().textField : props.disabled ? COLOR().textFieldDisabled : COLOR().textField,
                },
                disableUnderline: true
            }}
        />
    )
}



// Text
// ----

const TextFieldTextSelectBase = props => {

    const { corDestaque, desejavel, ...rest } = props

    return (
        props.disabled
            ?
                <CampoDisabled
                    label={props.label}
                    value={pesquisaDescricaoList(props.list, props.value)}
                />   
            :
                <TextFieldText
                    select

                    SelectProps={{
                        renderValue: option =>
                            <TextFieldRenderValue 
                                option={option}
                                {...props}
                            />
                    }}

                    {...rest}
                    desejavel={desejavel}
                />
    )
}

export const TextFieldTextSelect = props => {

    const { dontSort, desejavel, ...rest } = props

    const list = dontSort ? rest.list : sortAsc(rest.list)

    return (
        <TextFieldTextSelectBase
            {...rest}
            desejavel={desejavel}
        >
            {list?.map(
                (item, ind) => (
                    <MenuItem
                        value={item.id}
                        key={item.id}
                    >
                        {item.descricao}
                    </MenuItem>
                )
            )}
        </TextFieldTextSelectBase>
    )
}

export const TextFieldTextSelectRequired = props => {

    const { mensagemAlerta, desejavel, ...rest } = props

    return (
        <TextFieldTextSelect
            helperText={
                rest.value
                    ?
                        '' 
                    : 
                        mensagemAlerta
                            ?
                                mensagemAlerta
                            : 
                                desejavel
                                    ?
                                        MESSAGE().campoDesejavel
                                    : 
                                        MESSAGE().campoObrigatorio
            }
            {...rest}
            desejavel={desejavel}
        />
    )
}

export const TextFieldTextSelectDestaque = props => {
    return (
        <TextFieldTextSelect
            label={!props.value ? props.placeholder : ''}
            destaque={'sim'}
            {...props}
        />
    )
}

const TextFieldTextSelectTableBase = props => {
    return (
        <TextFieldTextSelectBase
            className=""    
            fullWidth
            {...props}
        />
    )
}

export const TextFieldTextSelectTable = props => {
    const list = sortAsc(props.list)

    return (
        <TextFieldTextSelectTableBase
            {...props}
        >
            {list?.map(
                (item, ind) => (
                    <MenuItem
                        value={item.id}
                        key={item.id}
                    >
                        {item.descricao}
                    </MenuItem>
                )
            )}
        </TextFieldTextSelectTableBase>
    )
}



// Number
// ------

const TextFieldNumberSelectBase = props => {
    const { corDestaque, ...rest } = props

    return (
        props.disabled
            ?
                <CampoDisabled
                    label={props.label}
                    value={pesquisaDescricaoList(props.list, props.value)}
                />   
            :
                <TextFieldNumber
                    select
                    
                    SelectProps={{
                        renderValue: option =>
                            <TextFieldRenderValue 
                                option={option}
                                {...props}
                            />
                    }}

                    {...rest}
                />
    )
}

export const TextFieldNumberSelect = props => {
    const list = sortAsc(props.list)

    return (
        <TextFieldNumberSelectBase
            {...props}
        >
            {list?.map(
                (item, ind) => (
                    <MenuItem
                        value={item.id}
                        key={item.id}
                    >
                        {item.descricao}
                    </MenuItem>
                )
            )}
        </TextFieldNumberSelectBase>
    )
}

export const TextFieldNumberSelectDestaque = props => {
    return (
        <TextFieldNumberSelect
            label={!props.value ? props.placeholder : ''}
            destaque={'sim'}
            {...props}
        />
    )
}

export const TextFieldNumberSelectRequired = props => {
    return (
        <TextFieldNumberSelect
            helperText={props.value === 0 ? '' : props.value ? '' : MESSAGE().campoObrigatorio}
            {...props}
        />
    )
}

export const TextFieldNumberSelectRequiredDestaque = props => {
    return (
        <TextFieldNumberSelectRequired
            label={!props.value ? props.placeholder : ''}
            destaque={'sim'}
            {...props}
        />
    )
}

const TextFieldNumberSelectTableBase = props => {
    return (
        <TextFieldNumberSelectBase
            className=""    
            fullWidth
            {...props}
        />
    )
}

export const TextFieldNumberSelectTable = props => {
    const list = sortAsc(props.list)

    return (
        <TextFieldNumberSelectTableBase
            {...props}
        >
            {list?.map(
                (item, ind) => (
                    <MenuItem
                        value={item.id}
                        key={item.id}
                    >
                        {item.descricao}
                    </MenuItem>
                )
            )}
        </TextFieldNumberSelectTableBase>
    )
}